module.exports = __webpack_public_path__ + "img/img38.7b068924.svg";